import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import {
  CreateChildren,
  CreateLeaveApplication,
  EmployeeProfile,
  GetAlternatePerson,
  GetChildrenName,
  GetCompoffWorkedDate,
  GetGenderList,
  GetLeaveType,
  ImageUpload,
} from "../../Repository/Api";
import { imagepath } from "../../Repository/BaseUrl";
import { NonEmptyValidation, StringValidation } from "../../Store/validate";
import { MaximumDate, MinimumDate, NumberOfDays, Profileinfo } from "../Common/FinancialYear";
import CustomModal from "../CustomModal";
import { errorMsg, successMsg } from "../Toastify";
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';

const Staffleaveapply = () => {
  const { first_name, desingation, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const navigate = useNavigate();

  const [profile, setProfile] = useState({});
  const [apply, setApply] = useState({});
  const [validation, setValidation] = useState({});
  const [leavetype, setLeavetype] = useState([]);
  const [alternatePerson, setAlternatePerson] = useState([]);
  const [compensation_date, setCompensation_date] = useState([]);
  const [genderType, setGenderType] = useState([]);
  const [childName, setChildName] = useState([]);
  const [childAddModel, setChildAddModel] = useState(false);
  const [createChild, setCreateChild] = useState([]);

  useEffect(() => {
    getLeaveType();
    getAlternatePersonName();
    getCompoffWorkedDate();
    getGender();
    getChildName();
    getProfile()
  }, []);

  const setData = (e, key) => {
    setApply({ ...apply, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const getProfile = async () => {
    const response = await EmployeeProfile(token);
    if (response && response.statusCode === 200) {
      setProfile(response?.data);
    } else {
      errorMsg(response.message);
    }
  };

  const setChildData = (e, key) => {
    setCreateChild({ ...createChild, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const setValidationValue = (key, value) => {
    setValidation({ ...validation, [key]: value });
  };

  const getLeaveType = async () => {
    const response = await GetLeaveType(token);
    if (response && response.statusCode === 200) {
      setLeavetype(response.data);
    } else {
      errorMsg(response.message);
    }
  };

  const getAlternatePersonName = async () => {
    const response = await GetAlternatePerson(token);
    if (response && response.statusCode === 200) {
      setAlternatePerson(response.data);
    } else {
      errorMsg(response.message);
    }
  };

  const getGender = async () => {
    const response = await GetGenderList(token);
    if (response && response.statusCode === 200) {
      setGenderType(response.data.master_data);
    } else {
      errorMsg(response.message);
    }
  };

  const getChildName = async () => {
    const response = await GetChildrenName(token);
    if (response && response.statusCode === 200) {
      setChildName(response.data);
    } else {
      errorMsg(response.message);
    }
  };

  const getCompoffWorkedDate = async () => {
    const response = await GetCompoffWorkedDate(token);
    if (response && response.statusCode === 200) {
      let workdate = response.data.map((label) => ({
        label: moment(label.date).format("DD-MM-yyyy"),
        value: label.id,
      }));
      setCompensation_date(workdate);
    } else {
      errorMsg(response.message);
    }
  };

  useEffect(() => {
    if (apply.start_date && apply.end_date) {
      var b = moment(apply?.start_date);
      var a = moment(apply?.end_date);

      setApply({
        ...apply,
        no_of_days: a.diff(b, "days") + 1,
      });
    } else if (apply?.duration_type === "half_day") {
      setApply({
        ...apply,
        no_of_days: 0.5,
      });
    } else if (apply?.start_date) {
      var d = moment(apply?.start_date);
      var c = moment(apply?.start_date);
      setApply({
        ...apply,
        no_of_days: c.diff(d, "days") + 1,
      });
    } else {
      var g = "";
      setApply({
        ...apply,
        no_of_days: g,
      });
    }
  }, [apply?.start_date, apply?.end_date]);

  const UploadDocument = async (e, key) => {
    const file = e.target.files[0];

    const maxSizeInBytes = 2 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      errorMsg("File size exceeds the limit of 2MB");
      return;
    }

    let formData = new FormData();
    let str = file.name;
    formData.append("file", file);
    formData.append("fileName", moment().format("YYYYMMDDHHmmss") + "_" + str);
    formData.append("file_path", "/reference_document");
    const response = await ImageUpload(formData);
    if (response && response.statusCode === 200) {
      setData(response.data, key);
      successMsg(response.message);
    } else {
      errorMsg(response.message);
    }
  };

  const qwerty = (apply?.start_date + ' ' + apply?.start_time)

  const handleSubmit = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.nature_of_leave_id = NonEmptyValidation(apply?.nature_of_leave_id);

    if (
      leavetype.filter(
        (val) =>
          val.code === "permissions" && val.id === apply?.nature_of_leave_id
      ).length
    ) {
      validate.start_date = NonEmptyValidation(apply?.start_date);
      validate.start_time = NonEmptyValidation(apply?.start_time);
      validate.end_time = NonEmptyValidation(apply?.end_time);
      validate.reason = NonEmptyValidation(apply?.reason);
    } else if (
      leavetype.filter(
        (val) =>
          val.code === "out_of_station" && val.id === apply?.nature_of_leave_id
      ).length
    ) {
      validate.start_date = NonEmptyValidation(apply?.start_date);
      validate.end_date = NonEmptyValidation(apply?.end_date);
      validate.address = NonEmptyValidation(apply?.address);
      validate.out_of_station_type = NonEmptyValidation(apply?.out_of_station_type);
      validate.reason = NonEmptyValidation(apply?.reason);
    } else {
      validate.duration_type = NonEmptyValidation(apply?.duration_type);
      if (apply?.duration_type === "half_day") {
        validate.half_day_leave_type = NonEmptyValidation(
          apply?.half_day_leave_type
        );
      }
      if (apply?.duration_type === "multiple_days") {
        validate.start_date = NonEmptyValidation(apply?.start_date);
        validate.end_date = NonEmptyValidation(apply?.end_date);
      } else {
        validate.start_date = NonEmptyValidation(apply?.start_date);
      }
      if (
        (apply?.duration_type === "single_day" ||
          apply?.duration_type === "multiple_days") &&
        profile?.hod === true
      ) {
        validate.hod_alternate_person_id = NonEmptyValidation(
          apply?.hod_alternate_person_id
        );
      }
      if (profile?.officer_type === 'faculty') {
        validate.alternate = NonEmptyValidation(apply?.alternate);
        if (apply?.alternate === "arranged") {
          validate.alternate_person_id = NonEmptyValidation(
            apply?.alternate_person_id
          );
        }
      }

      validate.additional_responsibilities = NonEmptyValidation(
        apply?.additional_responsibilities
      );
      if (apply?.additional_responsibilities === "true") {
        validate.additional_responsibilities_alternate_person_id =
          NonEmptyValidation(
            apply?.additional_responsibilities_alternate_person_id
          );
      }
      validate.leaving_head_quaters = NonEmptyValidation(
        apply?.leaving_head_quaters
      );
      if (apply?.leaving_head_quaters === "true") {
        validate.location_during_leave_period = NonEmptyValidation(
          apply?.location_during_leave_period
        );
      }
      validate.address = NonEmptyValidation(apply?.address);
      validate.reason = NonEmptyValidation(apply?.reason);
      if (
        leavetype.filter(
          (val) =>
            (val.code === "special_casual_leave" &&
              val.id === apply?.nature_of_leave_id) ||
            (val.code === "on_duty" && val.id === apply?.nature_of_leave_id)
        ).length
      ) {
        validate.title_of_the_program = StringValidation(
          apply?.title_of_the_program
        );
        validate.topic = StringValidation(apply?.topic);
        validate.organized_by = StringValidation(apply?.organized_by);
        validate.reference_attachment = NonEmptyValidation(
          apply?.reference_attachment
        );
      }
      if (
        leavetype.filter(
          (val) =>
            val.code === "child_care_leave" &&
            val.id === apply?.nature_of_leave_id
        ).length
      ) {
        validate.children_id = NonEmptyValidation(apply?.children_id);
      }
      if (
        leavetype.filter(
          (val) =>
            val.code === "medical_leave" && val.id === apply?.nature_of_leave_id
        ).length
      ) {
        validate.commuted_type = NonEmptyValidation(apply?.commuted_type);
      }
      if (
        leavetype.filter(
          (val) =>
            val.code === "comp_off" && val.id === apply?.nature_of_leave_id
        ).length
      ) {
        validate.compensation_date = NonEmptyValidation(
          apply?.compensation_date
        );
      }
    }

    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      let Payload
      if (leavetype.filter((val) => val.code === "permissions" && val.id === apply?.nature_of_leave_id).length) {
        Payload = {
          nature_of_leave_id: apply?.nature_of_leave_id,
          no_of_days: apply?.no_of_days,
          start_date: (apply?.start_date + ' ' + apply?.start_time),
          end_date: (apply?.start_date + ' ' + apply?.end_time),
          reason: apply?.reason
        }
      } else {
        // Clone the apply object so we can modify it safely
        let payloadData = { ...apply };
        let finalReason = apply?.reason;
        
        // Handle out_of_station formatting
        if (leavetype.filter((val) => val.code === "out_of_station" && val.id === apply?.nature_of_leave_id).length) {
          finalReason = `${apply?.out_of_station_type} - ${apply?.reason}`;
          // Crucial step: Remove this from the payload so the backend doesn't reject it
          delete payloadData.out_of_station_type;
        }

        Payload = {
          ...payloadData,
          reason: finalReason,
          compensation_date: apply?.compensation_date?.map((date) => date.value),
        };
      }

      const response = await CreateLeaveApplication(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setApply({});
        setTimeout(() => {
          navigate("/app/Staff/Staffleavestatus");
        }, 1000);
        e.target.reset();
        setValidation({});
      } else {
        errorMsg(response.message);
      }
    }
  };

  const handleSubmitChild = async (e) => {
    e.preventDefault();
    let validate = {};
    validate.name = NonEmptyValidation(createChild?.name);
    validate.gender_id = NonEmptyValidation(createChild?.gender_id);
    validate.dob = NonEmptyValidation(createChild?.dob);
    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        name: createChild.name,
        gender_id: createChild.gender_id,
        dob: createChild.dob,
      };

      const response = await CreateChildren(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateChild({});
        setChildAddModel(false)
        getChildName()
      } else {
        errorMsg(response.message);
      }
    }
  };

  return (
    <>
      <div className="">
        <Profileinfo
          first_name={first_name}
          designation={desingation}
          department={department}
        />
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">Leave Application</h6>
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="row">
                    <div className="col-lg-3">
                      <label className="labeltext"> Nature of Leave *</label>
                      <select
                        className="fieldinput"
                        defaultValue={apply?.nature_of_leave_id}
                        onChange={(e) => {
                          setData(e.target.value, "nature_of_leave_id");
                        }}
                        onBlur={(e) => {
                          setValidationValue(
                            "nature_of_leave_id",
                            NonEmptyValidation(e.target.value)
                          );
                        }}
                      >
                        <option value="">Select Leave Type</option>
                        {leavetype?.map((e, index) => (
                          <option key={index} value={e.id}>
                            {e.name}
                          </option>
                        ))}
                      </select>
                      <small className="validationerror">
                        {validation?.nature_of_leave_id?.message
                          ? `Nature of Leave ${validation?.nature_of_leave_id?.message}`
                          : ""}
                      </small>
                    </div>
                    {
                      leavetype.filter(
                        (val) =>
                          val.code === "permissions" &&
                          val.id === apply?.nature_of_leave_id
                      ).length ? (
                        <>
                          <>
                            <div className="col-lg-3">
                              <div>
                                <label className="labeltext">Date *</label>
                                <input
                                  type="date"
                                  placeholder="Select Date"
                                  className="fieldinput"
                                  defaultValue={apply?.start_date}
                                  onChange={(e) =>
                                    setData(e.target.value, "start_date")
                                  }
                                  onBlur={(e) => {
                                    setValidationValue(
                                      "start_date",
                                      NonEmptyValidation(e.target.value)
                                    );
                                  }}
                                />
                              </div>
                              <small className="validationerror">
                                {validation?.start_date?.message
                                  ? `Start Date ${validation?.start_date?.message}` 
                                  : ""}
                              </small>
                            </div>
                            <div className="col-lg-3">
                              <div>
                                <label className="labeltext"> Start Time *</label>
                                <TimePicker
                                  showSecond={false}
                                  className="timePicker"
                                  onChange={(e) => {
                                    setData(moment(e).format('HH:mm'), "start_time")
                                  }
                                  }
                                  format='h:mm a'
                                  use12Hours
                                />
                              </div>
                              <small className="validationerror">
                                {validation?.start_time?.message
                                  ? `Start Time ${validation?.start_time?.message}`
                                  : ""}
                              </small>
                            </div>
                            <div className="col-lg-3">
                              <div>
                                <label className="labeltext">End Time *</label>
                                <TimePicker
                                  showSecond={false}
                                  className="timePicker"
                                  onChange={(e) => {
                                    setData(moment(e).format('HH:mm'), "end_time")
                                  }
                                  }
                                  format='h:mm a'
                                  use12Hours
                                />
                              </div>
                              <small className="validationerror">
                                {validation?.end_time?.message
                                  ? `End Time ${validation?.end_time?.message}`
                                  : ""}
                              </small>
                            </div>
                            <div className="col-lg-3">
                              <label className="labeltext"> Reason *</label>
                              <textarea
                                className="fieldinputtext"
                                placeholder="Enter Your Reason"
                                defaultValue={apply?.reason}
                                onChange={(e) => setData(e.target.value, "reason")}
                                onBlur={(e) => {
                                  setValidationValue(
                                    "reason",
                                    NonEmptyValidation(e.target.value)
                                  );
                                }}
                              />
                              <small className="validationerror">
                                {validation?.reason?.message
                                  ? `Reason ${validation?.reason?.message}`
                                  : ""}
                              </small>
                            </div>
                          </>
                        </>
                      ) :
                        leavetype.filter(
                          (val) =>
                            val.code === "out_of_station" &&
                            val.id === apply?.nature_of_leave_id
                        ).length ? (
                          <>
                            <div className="col-lg-3">
                              <div>
                                <label className="labeltext"> Start Date *</label>
                                <input
                                  type="date"
                                  placeholder="Start Date"
                                  className="fieldinput"
                                  defaultValue={apply?.start_date}
                                  onChange={(e) =>
                                    setData(e.target.value, "start_date")
                                  }
                                  onBlur={(e) => {
                                    setValidationValue(
                                      "start_date",
                                      NonEmptyValidation(e.target.value)
                                    );
                                  }}
                                />
                              </div>
                              <small className="validationerror">
                                {validation?.start_date?.message
                                  ? `Start Date ${validation?.start_date?.message}`
                                  : ""}
                              </small>
                            </div>
                            <div className="col-lg-3">
                              <div>
                                <label className="labeltext"> End Date *</label>
                                <input
                                  type="date"
                                  placeholder="End Date"
                                  className="fieldinput"
                                  defaultValue={apply?.end_date}
                                  onChange={(e) =>
                                    setData(e.target.value, "end_date")
                                  }
                                  onBlur={(e) => {
                                    setValidationValue(
                                      "end_date",
                                      NonEmptyValidation(e.target.value)
                                    );
                                  }}
                                  min={moment(apply?.start_date).format(
                                    "YYYY-MM-DD"
                                  )}
                                />
                              </div>
                              <small className="validationerror">
                                {validation?.end_date?.message
                                  ? `End Date ${validation?.end_date?.message}`
                                  : ""}
                              </small>
                            </div>
                            <div className="col-lg-3">
                              <label className="labeltext">
                                Address - Leave Period *
                              </label>
                              <textarea
                                className="fieldinputtext"
                                placeholder="Enter Your Address"
                                defaultValue={apply?.address}
                                onChange={(e) => setData(e.target.value, "address")}
                                onBlur={(e) => {
                                  setValidationValue(
                                    "address",
                                    NonEmptyValidation(e.target.value)
                                  );
                                }}
                              />
                              <small className="validationerror">
                                {validation?.address?.message
                                  ? `Address ${validation?.address?.message}`
                                  : ""}
                              </small>
                            </div>
                            
                            <div className="col-lg-3">
                              <label className="labeltext"> Type *</label>
                              <select
                                className="fieldinput"
                                defaultValue={apply?.out_of_station_type}
                                onChange={(e) => setData(e.target.value, "out_of_station_type")}
                                onBlur={(e) => {
                                  setValidationValue(
                                    "out_of_station_type",
                                    NonEmptyValidation(e.target.value)
                                  );
                                }}
                              >
                                <option value="">Select Type</option>
                                <option value="Personal">Personal</option>
                                <option value="Professional">Professional</option>
                              </select>
                              <small className="validationerror">
                                {validation?.out_of_station_type?.message
                                  ? `Type ${validation?.out_of_station_type?.message}`
                                  : ""}
                              </small>
                            </div>

                            <div className="col-lg-3">
                              <label className="labeltext"> Reason *</label>
                              <textarea
                                className="fieldinputtext"
                                placeholder="Enter Your Reason"
                                defaultValue={apply?.reason}
                                onChange={(e) => setData(e.target.value, "reason")}
                                onBlur={(e) => {
                                  setValidationValue(
                                    "reason",
                                    NonEmptyValidation(e.target.value)
                                  );
                                }}
                              />
                              <small className="validationerror">
                                {validation?.reason?.message
                                  ? `Reason ${validation?.reason?.message}`
                                  : ""}
                              </small>
                            </div>
                          </>
                        ) : (
                          <>
                            {leavetype.filter(
                              (val) =>
                                val.code === "child_care_leave" &&
                                val.id === apply?.nature_of_leave_id
                            ).length ? (
                              <>
                                <div className="col-lg-3">
                                  <label className="labeltext">Children Name</label>
                                  <select
                                    className="fieldinput"
                                    defaultValue={apply?.children_id}
                                    onChange={(e) => {
                                      setData(e.target.value, "children_id");
                                    }}
                                    onBlur={(e) => {
                                      setValidationValue(
                                        "children_id",
                                        NonEmptyValidation(e.target.value)
                                      );
                                    }}
                                  >
                                    <option value="">Select Children</option>
                                    {childName?.map((e, index) => (
                                      <option key={index} value={e.id}>
                                        {e.name}
                                      </option>
                                    ))}
                                  </select>
                                  <small className="validationerror">
                                    {validation?.children_id?.message
                                      ? `Children Name ${validation?.children_id?.message}`
                                      : ""}
                                  </small>
                                </div>
                                {childName?.length >= 2 ? (
                                  null
                                ) : (
                                  <div className="col-lg-3">
                                    <label className="labeltext">
                                      Add Children
                                    </label>
                                    <div>
                                      <button
                                        type="button"
                                        className="addbutton"
                                        onClick={() => {
                                          setChildAddModel(true);
                                        }}
                                      >
                                        Add Children
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </>
                            ) : (
                              null
                            )}
                            {leavetype.filter(
                              (val) =>
                                val.code === "medical_leave" &&
                                val.id === apply?.nature_of_leave_id
                            ).length ? (
                              <div className="col-lg-3">
                                <label className="labeltext">Commuted Leave</label>
                                <select
                                  className="fieldinput"
                                  defaultValue={apply?.commuted_type}
                                  onChange={(e) =>
                                    setData(e.target.value, "commuted_type")
                                  }
                                  onBlur={(e) => {
                                    setValidationValue(
                                      "commuted_type",
                                      NonEmptyValidation(e.target.value)
                                    );
                                  }}
                                >
                                  <option value="">Select Option</option>
                                  <option value="half_pay">Half Pay</option>
                                  <option value="full_pay">Full Pay</option>
                                </select>
                                <small className="validationerror">
                                  {validation?.commuted_type?.message
                                    ? `Commuted Leave ${validation?.commuted_type?.message}`
                                    : ""}
                                </small>
                              </div>
                            ) : (
                              null
                            )}
                            {leavetype.filter(
                              (val) =>
                                (val.code === "special_casual_leave" &&
                                  val.id === apply?.nature_of_leave_id) ||
                                (val.code === "on_duty" &&
                                  val.id === apply?.nature_of_leave_id)
                            ).length ? (
                              <>
                                <div className="col-lg-3">
                                  <div>
                                    <label className="labeltext">
                                      Title of Training Programme / Assignment
                                    </label>
                                    <input
                                      type="text"
                                      placeholder="Enter Title of Programme"
                                      className="fieldinput"
                                      defaultValue={apply?.title_of_the_program}
                                      onChange={(e) =>
                                        setData(
                                          e.target.value,
                                          "title_of_the_program"
                                        )
                                      }
                                      onBlur={(e) => {
                                        setValidationValue(
                                          "title_of_the_program",
                                          NonEmptyValidation(e.target.value)
                                        );
                                      }}
                                    />
                                  </div>
                                  <small className="validationerror">
                                    {validation?.title_of_the_program?.message
                                      ? `Title of Programme ${validation?.title_of_the_program?.message}`
                                      : ""}
                                  </small>
                                </div>
                                <div className="col-lg-3">
                                  <div>
                                    <label className="labeltext">
                                      Topic To be Handled
                                    </label>
                                    <input
                                      type="text"
                                      placeholder="Enter Topic To be Handled"
                                      className="fieldinput"
                                      defaultValue={apply?.topic}
                                      onChange={(e) =>
                                        setData(e.target.value, "topic")
                                      }
                                      onBlur={(e) => {
                                        setValidationValue(
                                          "topic",
                                          NonEmptyValidation(e.target.value)
                                        );
                                      }}
                                    />
                                  </div>
                                  <small className="validationerror">
                                    {validation?.topic?.message
                                      ? `Topic ${validation?.topic?.message}`
                                      : ""}
                                  </small>
                                </div>
                                <div className="col-lg-3">
                                  <div>
                                    <label className="labeltext">
                                      Organized By
                                    </label>
                                    <input
                                      type="text"
                                      placeholder="Enter Organized By"
                                      className="fieldinput"
                                      defaultValue={apply?.organized_by}
                                      onChange={(e) =>
                                        setData(e.target.value, "organized_by")
                                      }
                                      onBlur={(e) => {
                                        setValidationValue(
                                          "organized_by",
                                          NonEmptyValidation(e.target.value)
                                        );
                                      }}
                                    />
                                  </div>
                                  <small className="validationerror">
                                    {validation?.organized_by?.message
                                      ? `Organized By ${validation?.organized_by?.message}`
                                      : ""}
                                  </small>
                                </div>
                              </>
                            ) : (
                              null
                            )}
                            {leavetype.filter(
                              (val) =>
                                (val.code === "casual_leave" ||
                                  val.code === "special_casual_leave") &&
                                val.id === apply?.nature_of_leave_id
                            ).length ? (
                              <div className="col-lg-3">
                                <label className="labeltext">Duration Type *</label>
                                <select
                                  className="fieldinput"
                                  defaultValue={apply?.duration_type}
                                  onChange={(e) =>
                                    setData(e.target.value, "duration_type")
                                  }
                                  onBlur={(e) => {
                                    setValidationValue(
                                      "duration_type",
                                      NonEmptyValidation(e.target.value)
                                    );
                                  }}
                                >
                                  <option value="">Select Option</option>
                                  <option value="single_day">Single Day</option>
                                  <option value="multiple_days">
                                    Multiple Days
                                  </option>
                                  <option value="half_day">Half Day</option>
                                </select>
                                <small className="validationerror">
                                  {validation?.duration_type?.message
                                    ? `Duration Type ${validation?.duration_type?.message}`
                                    : ""}
                                </small>
                              </div>
                            ) : (
                              <div className="col-lg-3">
                                <label className="labeltext">Duration Type *</label>
                                <select
                                  className="fieldinput"
                                  defaultValue={apply?.duration_type}
                                  onChange={(e) =>
                                    setData(e.target.value, "duration_type")
                                  }
                                  onBlur={(e) => {
                                    setValidationValue(
                                      "duration_type",
                                      NonEmptyValidation(e.target.value)
                                    );
                                  }}
                                >
                                  <option value="">Select Option</option>
                                  <option value="single_day">Single Day</option>
                                  <option value="multiple_days">
                                    Multiple Days
                                  </option>
                                  <option value="half_day">Half Day</option>
                                </select>
                                <small className="validationerror">
                                  {validation?.duration_type?.message
                                    ? `Duration Type ${validation?.duration_type?.message}`
                                    : ""}
                                </small>
                              </div>
                            )}
                            {apply?.duration_type === "half_day" ? (
                              <div className="col-lg-3">
                                <div>
                                  <label className="labeltext">Half Day Type</label>
                                  <select
                                    className="fieldinput"
                                    defaultValue={apply?.half_day_leave_type}
                                    onChange={(e) =>
                                      setData(e.target.value, "half_day_leave_type")
                                    }
                                    onBlur={(e) => {
                                      setValidationValue(
                                        "half_day_leave_type",
                                        NonEmptyValidation(e.target.value)
                                      );
                                    }}
                                  >
                                    <option value="">Select Option</option>
                                    <option value="forenoon">
                                      Morning (9am-1pm)
                                    </option>
                                    <option value="afternoon">
                                      Afternoon (1pm-6pm)
                                    </option>
                                  </select>
                                </div>
                                <small className="validationerror">
                                  {validation?.half_day_leave_type?.message
                                    ? `Half Day Type ${validation?.half_day_leave_type?.message}`
                                    : ""}
                                </small>
                              </div>
                            ) : (
                              null
                            )}
                            {apply?.duration_type === "multiple_days" ? (
                              <>
                                <div className="col-lg-3">
                                  <div>
                                    <label className="labeltext">
                                      Start Date *
                                    </label>
                                    <input
                                      type="date"
                                      placeholder="Start Date"
                                      className="fieldinput"
                                      defaultValue={apply?.start_date}
                                      onChange={(e) =>
                                        setData(e.target.value, "start_date")
                                      }
                                      onBlur={(e) => {
                                        setValidationValue(
                                          "start_date",
                                          NonEmptyValidation(e.target.value)
                                        );
                                      }}
                                    />
                                  </div>
                                  <small className="validationerror">
                                    {validation?.start_date?.message
                                      ? `Start Date ${validation?.start_date?.message}`
                                      : ""}
                                  </small>
                                </div>
                                <div className="col-lg-3">
                                  <div>
                                    <label className="labeltext"> End Date *</label>
                                    <input
                                      type="date"
                                      placeholder="End Date"
                                      className="fieldinput"
                                      defaultValue={apply?.end_date}
                                      onChange={(e) =>
                                        setData(e.target.value, "end_date")
                                      }
                                      onBlur={(e) => {
                                        setValidationValue(
                                          "end_date",
                                          NonEmptyValidation(e.target.value)
                                        );
                                      }}
                                      min={moment(apply?.start_date).format(
                                        "YYYY-MM-DD"
                                      )}
                                    />
                                  </div>
                                  <small className="validationerror">
                                    {validation?.end_date?.message
                                      ? `End Date ${validation?.end_date?.message}`
                                      : ""}
                                  </small>
                                </div>
                              </>
                            ) : (
                              <div className="col-lg-3">
                                <div>
                                  <label className="labeltext"> Date *</label>
                                  <input
                                    type="date"
                                    placeholder="Start Date"
                                    className="fieldinput"
                                    defaultValue={apply?.start_date}
                                    onChange={(e) =>
                                      setData(e.target.value, "start_date")
                                    }
                                    onBlur={(e) => {
                                      setValidationValue(
                                        "start_date",
                                        NonEmptyValidation(e.target.value)
                                      );
                                    }}
                                  />
                                </div>
                                <small className="validationerror">
                                  {validation?.start_date?.message
                                    ? `Start Date ${validation?.start_date?.message}`
                                    : ""}
                                </small>
                              </div>
                            )}
                            <div className="col-lg-3">
                              <label className="labeltext"> No. of Days *</label>
                              <input
                                type="text"
                                placeholder="Enter No. of days"
                                className="fieldinput"
                                defaultValue={apply?.no_of_days}
                                disabled
                              />
                            </div>
                            {leavetype.filter(
                              (val) =>
                                val.code === "comp_off" &&
                                val.id === apply?.nature_of_leave_id
                            ).length ? (
                              <div className="col-lg-3">
                                <label className="labeltext">Worked Date</label>
                                <CreatableSelect
                                  isMulti
                                  options={compensation_date}
                                  placeholder="Choose your Date"
                                  value={apply?.compensation_date}
                                  onChange={(e) => {
                                    setData(e, "compensation_date");
                                  }}
                                />
                                <small className="validationerror">
                                  {validation?.compensation_date?.message
                                    ? `Count ${validation?.compensation_date?.message}`
                                    : ""}
                                </small>
                              </div>
                            ) : (
                              null
                            )}
                            <div className="col-lg-3">
                              <label className="labeltext">Prefix Holidays</label>
                              <input
                                type="date"
                                placeholder="Prefix"
                                className="fieldinput"
                                defaultValue={apply?.prefix}
                                onChange={(e) => setData(e.target.value, "prefix")}
                                max={MinimumDate(apply?.start_date, 1)}
                                min={MinimumDate(apply?.start_date, 7)}
                              />
                              <br />
                              <small>
                                No of prefix Holidays :
                                <span className="fw-bold ms-2">
                                  {NumberOfDays(apply?.prefix, apply?.start_date)}
                                </span>
                              </small>
                            </div>
                            <div className="col-lg-3">
                              <label className="labeltext">Suffix Holidays</label>
                              <input
                                type="date"
                                placeholder="Suffix"
                                className="fieldinput"
                                defaultValue={apply?.suffix}
                                onChange={(e) => setData(e.target.value, "suffix")}
                                min={apply?.no_of_days === 1 ? MaximumDate(apply?.start_date, 1) : MaximumDate(apply?.end_date, 1)}
                                max={apply?.no_of_days === 1 ? MaximumDate(apply?.start_date, 7) : MaximumDate(apply?.end_date, 7)}
                              />
                              <br />
                              <small>
                                No of suffix Holidays :
                                <span className="fw-bold ms-2">
                                  {apply?.no_of_days !== 1 ?
                                    NumberOfDays(apply?.end_date, apply?.suffix) :
                                    NumberOfDays(apply?.start_date, apply?.suffix)
                                  }
                                </span>
                              </small>
                            </div>
                            {profile?.officer_type === 'faculty' &&
                              <>
                                <div className="col-lg-3">
                                  <label className="labeltext">Alternate *</label>
                                  <select
                                    className="fieldinput"
                                    defaultValue={apply?.alternate}
                                    onChange={(e) =>
                                      setData(e.target.value, "alternate")
                                    }
                                    onBlur={(e) => {
                                      setValidationValue(
                                        "alternate",
                                        NonEmptyValidation(e.target.value)
                                      );
                                    }}
                                  >
                                    <option value="">Select Option</option>
                                    <option value="arranged">Arranged</option>
                                    <option value="no_class">No Class</option>
                                  </select>
                                  <small className="validationerror">
                                    {validation?.alternate?.message
                                      ? `Alternate ${validation?.alternate?.message}`
                                      : ""}
                                  </small>
                                </div>
                                {apply?.alternate === "arranged" ? (
                                  <div className="col-lg-3">
                                    <label className="labeltext">
                                      Alternate Person
                                    </label>
                                    <select
                                      className="fieldinput"
                                      defaultValue={apply?.alternate_person_id}
                                      onChange={(e) => {
                                        setData(e.target.value, "alternate_person_id");
                                      }}
                                      onBlur={(e) => {
                                        setValidationValue(
                                          "alternate_person_id",
                                          NonEmptyValidation(e.target.value)
                                        );
                                      }}
                                    >
                                      <option value="">Select Person</option>
                                      {alternatePerson?.map((e, index) => (
                                        <option key={index} value={e.id}>
                                          {e.name}
                                        </option>
                                      ))}
                                    </select>
                                    <small className="validationerror">
                                      {validation?.alternate_person_id?.message
                                        ? `Alternate Person ${validation?.alternate_person_id?.message}`
                                        : ""}
                                    </small>
                                  </div>
                                ) : (
                                  null
                                )}
                              </>
                            }
                            <div className="col-lg-3">
                              <label className="labeltext">
                                Additional Responsibility *
                              </label>
                              <select
                                className="fieldinput"
                                defaultValue={apply?.additional_responsibilities}
                                onChange={(e) =>
                                  setData(
                                    e.target.value,
                                    "additional_responsibilities"
                                  )
                                }
                                onBlur={(e) => {
                                  setValidationValue(
                                    "additional_responsibilities",
                                    NonEmptyValidation(e.target.value)
                                  );
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                              </select>
                              <small className="validationerror">
                                {validation?.additional_responsibilities?.message
                                  ? `Additional Responsibility ${validation?.additional_responsibilities?.message}`
                                  : ""}
                              </small>
                            </div>
                            {apply?.additional_responsibilities === "true" ? (
                              <div className="col-lg-3">
                                <label className="labeltext">
                                  Additional Responsible Person
                                </label>
                                <select
                                  className="fieldinput"
                                  defaultValue={
                                    apply?.additional_responsibilities_alternate_person_id
                                  }
                                  onChange={(e) => {
                                    setData(
                                      e.target.value,
                                      "additional_responsibilities_alternate_person_id"
                                    );
                                  }}
                                  onBlur={(e) => {
                                    setValidationValue(
                                      "additional_responsibilities_alternate_person_id",
                                      NonEmptyValidation(e.target.value)
                                    );
                                  }}
                                >
                                  <option value="">Select Alternate Person</option>
                                  {alternatePerson?.map((e, index) => (
                                    <option key={index} value={e.id}>
                                      {e.name}
                                    </option>
                                  ))}
                                </select>
                                <small className="validationerror">
                                  {validation
                                    ?.additional_responsibilities_alternate_person_id
                                    ?.message
                                    ? `Additional Responsible Person ${validation?.additional_responsibilities_alternate_person_id?.message}`
                                    : ""}
                                </small>
                              </div>
                            ) : (
                              null
                            )}
                            {(apply?.duration_type === "single_day" ||
                              apply?.duration_type === "multiple_days") &&
                              profile?.hod === true ? (
                              <div className="col-lg-3">
                                <div>
                                  <label className="labeltext">
                                    HOD Alternate Person
                                  </label>
                                  <select
                                    className="fieldinput"
                                    defaultValue={apply?.hod_alternate_person_id}
                                    onChange={(e) => {
                                      setData(
                                        e.target.value,
                                        "hod_alternate_person_id"
                                      );
                                    }}
                                    onBlur={(e) => {
                                      setValidationValue(
                                        "hod_alternate_person_id",
                                        NonEmptyValidation(e.target.value)
                                      );
                                    }}
                                  >
                                    <option value="">Select Person</option>
                                    {alternatePerson?.map((e, index) => (
                                      <option key={index} value={e.id}>
                                        {e.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <small className="validationerror">
                                  {validation?.hod_alternate_person_id?.message
                                    ? `Hod Alternate ${validation?.hod_alternate_person_id?.message}`
                                    : ""}
                                </small>
                              </div>
                            ) : (
                              null
                            )}
                            {leavetype.filter(
                              (val) =>
                                (val.code === "special_casual_leave" &&
                                  val.id === apply?.nature_of_leave_id) ||
                                (val.code === "on_duty" &&
                                  val.id === apply?.nature_of_leave_id)
                            ).length ? (
                              <div className="col-lg-3">
                                <label className="labeltext">
                                  Ref... (Attach Document)
                                </label>
                                <input
                                  type="file"
                                  className="fieldinputfile"
                                  id="myfile"
                                  onChange={(e) =>
                                    UploadDocument(e, "reference_attachment")
                                  }
                                  accept="application/pdf"
                                />
                                <br />
                                <small className="d-flex">Max File upload:200kb</small>
                                <small className="validationerror">
                                  {validation?.reference_attachment?.message
                                    ? `Attachment ${validation?.reference_attachment?.message}`
                                    : ""}
                                </small>
                                {!apply?.reference_attachment ? (
                                  null
                                ) : (
                                  <span
                                    className="namelink"
                                    onClick={() => {
                                      window.open(
                                        `${imagepath}${apply?.reference_attachment}`,
                                        "_blank"
                                      );
                                    }}
                                  >
                                    View Document
                                  </span>
                                )}
                              </div>
                            ) : (
                              null
                            )}
                            <div className="col-lg-3">
                              <label className="labeltext">
                                Leaving Headquarters *
                              </label>
                              <select
                                className="fieldinput"
                                defaultValue={apply?.leaving_head_quaters}
                                onChange={(e) =>
                                  setData(e.target.value, "leaving_head_quaters")
                                }
                                onBlur={(e) => {
                                  setValidationValue(
                                    "leaving_head_quaters",
                                    NonEmptyValidation(e.target.value)
                                  );
                                }}
                              >
                                <option value="">Select Option</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                              </select>
                              <small className="validationerror">
                                {validation?.leaving_head_quaters?.message
                                  ? `Leaving Headquarters ${validation?.leaving_head_quaters?.message}`
                                  : ""}
                              </small>
                            </div>
                            {apply?.leaving_head_quaters === "true" ? (
                              <div className="col-lg-3">
                                <label className="labeltext"> Location</label>
                                <input
                                  type="text"
                                  placeholder="Enter Location"
                                  className="fieldinput"
                                  defaultValue={apply?.location_during_leave_period}
                                  onChange={(e) =>
                                    setData(
                                      e.target.value,
                                      "location_during_leave_period"
                                    )
                                  }
                                  onBlur={(e) => {
                                    setValidationValue(
                                      "location_during_leave_period",
                                      NonEmptyValidation(e.target.value)
                                    );
                                  }}
                                />
                                <small className="validationerror">
                                  {validation?.location_during_leave_period?.message
                                    ? `Location ${validation?.location_during_leave_period?.message}`
                                    : ""}
                                </small>
                              </div>
                            ) : (
                              null
                            )}
                            <div className="col-lg-3">
                              <label className="labeltext">
                                Address - Leave Period *
                              </label>
                              <textarea
                                className="fieldinputtext"
                                placeholder="Enter Your Address"
                                defaultValue={apply?.address}
                                onChange={(e) => setData(e.target.value, "address")}
                                onBlur={(e) => {
                                  setValidationValue(
                                    "address",
                                    NonEmptyValidation(e.target.value)
                                  );
                                }}
                              />
                              <small className="validationerror">
                                {validation?.address?.message
                                  ? `Address ${validation?.address?.message}`
                                  : ""}
                              </small>
                            </div>
                            <div className="col-lg-3">
                              <label className="labeltext"> Reason *</label>
                              <textarea
                                className="fieldinputtext"
                                placeholder="Enter Your Reason"
                                defaultValue={apply?.reason}
                                onChange={(e) => setData(e.target.value, "reason")}
                                onBlur={(e) => {
                                  setValidationValue(
                                    "reason",
                                    NonEmptyValidation(e.target.value)
                                  );
                                }}
                              />
                              <small className="validationerror">
                                {validation?.reason?.message
                                  ? `Reason ${validation?.reason?.message}`
                                  : ""}
                              </small>
                            </div>
                          </>
                        )}
                  </div>
                  <div className="centertext my-5">
                    <button className="requestbtn">Submit Application</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Childaddmodel */}
        <CustomModal
          open={childAddModel}
          onClickOutside={() => {
            setChildAddModel(false);
            setCreateChild({});
            setValidation({});
          }}
        >
          <form onSubmit={(e) => handleSubmitChild(e)}>
            <div className="modal-content Modal-View m-auto">
              <div className="modalHeader text-center py-2">
                <h5 className="font-bold mt-2">Add Children</h5>
              </div>
              <div className="modal-body p-0 ">
                <div className="container">
                  <div className="row d-flex align-items-center justify-content-center  mt-0">
                    <div className="container ">
                      <div className="row justify-content-center">
                        <div className="col-lg-8">
                          <div className=" my-5 px-3">
                            <div className="row justify-content-center mt-2">
                              <div className="col-lg-10">
                                <div className="mb-3">
                                  <label className="labeltext">
                                    Name of the Children:
                                  </label>
                                  <input
                                    type="text"
                                    className="fieldinput"
                                    placeholder="Enter Children Name"
                                    defaultValue={createChild.name}
                                    onChange={(e) => {
                                      setChildData(e.target.value, "name");
                                    }}
                                    onBlur={(e) => {
                                      setValidationValue(
                                        "name",
                                        NonEmptyValidation(e.target.value)
                                      );
                                    }}
                                  />
                                  <small className="validationerror">
                                    {validation?.name?.message
                                      ? `Nature of Leave ${validation?.name?.message}`
                                      : ""}
                                  </small>
                                </div>
                                <div className="mb-3">
                                  <label className="labeltext">Gender</label>
                                  <select
                                    className="fieldinput"
                                    defaultValue={apply?.gender_id}
                                    onChange={(e) => {
                                      setChildData(e.target.value, "gender_id");
                                    }}
                                    onBlur={(e) => {
                                      setValidationValue(
                                        "gender_id",
                                        NonEmptyValidation(e.target.value)
                                      );
                                    }}
                                  >
                                    <option value="">Select Gender</option>
                                    {genderType?.map((e, index) => (
                                      <option key={index} value={e.id}>
                                        {e.master_value}
                                      </option>
                                    ))}
                                  </select>
                                  <small className="validationerror">
                                    {validation?.gender_id?.message
                                      ? `Nature of Leave ${validation?.gender_id?.message}`
                                      : ""}
                                  </small>
                                </div>
                                <div className="mb-3">
                                  <label className="labeltext">DOB</label>
                                  <input
                                    type="date"
                                    placeholder="DOB"
                                    className="fieldinput"
                                    defaultValue={apply?.dob}
                                    onChange={(e) =>
                                      setChildData(e.target.value, "dob")
                                    }
                                    onBlur={(e) => {
                                      setValidationValue(
                                        "dob",
                                        NonEmptyValidation(e.target.value)
                                      );
                                    }}
                                  />
                                  <small className="validationerror">
                                    {validation?.dob?.message
                                      ? `Nature of Leave ${validation?.dob?.message}`
                                      : ""}
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div className="my-3">
                  <button
                    type="button"
                    className="btn mx-2 modelclosebtn"
                    onClick={() => {
                      setChildAddModel(false);
                      setValidation({});
                      setCreateChild({});
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button className="btn mx-2 modelsubmitbtn">Add Child</button>
                </div>
              </div>
            </div>
          </form>
        </CustomModal>
      </div>
    </>
  );
};

export default Staffleaveapply;